var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate, t } from "../I18N";

import Modal from "../Layout/Modal";
import { Loader } from "../components/Elements/Loader";

class Confirm extends Component {
  static getDerivedStateFromProps(newProps, state) {
    if (newProps.accept !== state.accept) {
      return { isOpen: true, accept: newProps.accept };
    }

    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.isOpen,
      isLoading: props.isLoading,
      confirmInputValue: ''
    };

    this.accept = this.accept.bind(this);
    this.cancel = this.cancel.bind(this);
    this.close = this.close.bind(this);
    this.handleInput = this.handleInput.bind(this);
  }

  close() {
    this.setState({ isOpen: false, confirmInputValue: '', isLoading: false });
  }

  accept() {
    if (this.props.accept) {
      const actionResponse = this.props.accept();
      if (actionResponse && actionResponse instanceof Promise) {
        this.setState({ isLoading: true });
        actionResponse.then(this.close);
        actionResponse.catch(this.close);
        return;
      }
    }
    this.close();
  }

  cancel() {
    if (this.props.cancel) {
      this.props.cancel();
    }
    this.close();
  }

  handleInput(e) {
    this.setState({ confirmInputValue: e.target.value });
  }

  renderExtraConfirm() {
    return (/*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "If you want to continue, please type"), " '",
      this.props.extraConfirmWord, "'", ' '
      ), /*#__PURE__*/
      _jsx("input", { type: "text", onChange: this.handleInput, value: this.state.confirmInputValue })
      ));

  }

  render() {
    const { type, acceptLabel, zIndex, message, title, messageKey } = this.props;
    return (/*#__PURE__*/
      _jsx(Modal, { isOpen: this.state.isOpen, type: type, zIndex: zIndex }, void 0, /*#__PURE__*/
      _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
      _jsx("h4", {}, void 0,
      typeof title !== 'string' && title,
      typeof title === 'string' && /*#__PURE__*/_jsx(Translate, {}, void 0, title)
      ), /*#__PURE__*/
      _jsx("p", {}, void 0,
      typeof message !== 'string' && message,
      typeof message === 'string' && /*#__PURE__*/
      _jsx(Translate, { translationKey: messageKey }, void 0, message)

      ),
      this.props.extraConfirm && !this.state.isLoading && this.renderExtraConfirm(),
      this.state.isLoading && /*#__PURE__*/_jsx(Loader, {})
      ),

      !this.state.isLoading && /*#__PURE__*/
      _jsx(Modal.Footer, {}, void 0,
      !this.props.noCancel && /*#__PURE__*/
      _jsx("button", { type: "button", className: "btn btn-default cancel-button", onClick: this.cancel }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Cancel")
      ), /*#__PURE__*/

      _jsx("button", {
        type: "button",
        disabled:
        this.props.extraConfirm &&
        this.state.confirmInputValue !== this.props.extraConfirmWord,

        className: `btn confirm-button btn-${type}`,
        onClick: this.accept }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, acceptLabel)
      )
      )

      ));

  }
}

Confirm.defaultProps = {
  isLoading: false,
  extraConfirm: false,
  isOpen: false,
  noCancel: false,
  type: 'danger',
  title: 'Confirm action',
  messageKey: '',
  message: 'Are you sure you want to continue?',
  extraConfirmWord: t('System', 'CONFIRM', null, false),
  acceptLabel: 'Accept',
  zIndex: 99
};

















export { Confirm };
export default Confirm;